module.exports = __webpack_public_path__ + "img/CB.f9e929d6.png";